export default __webpack_public_path__ + "static/media/lyftCheckBox.42feac66.png";